import { Button, CityState, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLocationQuickInfo extends Layout {
    buttonOpenLocation: Button;
    citystate1: CityState;
    labelFri: Label;
    labelLat: Label;
    labelLatitude: Label;
    labelLocationHours: Label;
    labelLon: Label;
    labelLongitude: Label;
    labelMon: Label;
    labelSat: Label;
    labelSun: Label;
    labelThu: Label;
    labelTue: Label;
    labelWed: Label;
    panel1: Panel;
    panel5: Panel;
    panelLocationHours: Panel;
    panelLocationHoursHeader: Label;
    sourceLocation: DataSource;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxContactEmail: Label;
    textboxFridayClose: Textbox;
    textboxFridayOpen: Textbox;
    textboxId: Textbox;
    textboxMondayClose: Textbox;
    textboxMondayOpen: Textbox;
    textboxName: Textbox;
    textboxSaturdayClose: Textbox;
    textboxSaturdayOpen: Textbox;
    textboxSundayClose: Textbox;
    textboxSundayOpen: Textbox;
    textboxThursdayClose: Textbox;
    textboxThursdayOpen: Textbox;
    textboxTuesdayClose: Textbox;
    textboxTuesdayOpen: Textbox;
    textboxWednesdayClose: Textbox;
    textboxWednesdayOpen: Textbox;
}
